'use client';

import { SignInForm } from '@/components/molecules/SignInForm';
import { LoginTemplate } from '@/components/templates/LoginTemplate';
import { LocalStorageKeys } from '@/enums/LocalStorageKeys';
import { OtpAuthForm } from '../molecules/OtpAuthForm';
import { AnimatePresence } from 'motion/react';
import { useEffect } from 'react';
import { TenantOptionDTO } from '@/services/dto/auth.dto';
import { TenantSelectionForm } from '../molecules/TenantSelectionForm';

interface AuthPageProps {
  otpEmailPreview?: string;
  tenantOptions?: TenantOptionDTO[];
}

export default function AuthPage({ otpEmailPreview, tenantOptions }: AuthPageProps) {
  useEffect(() => {
    const storedTheme = localStorage.getItem(LocalStorageKeys.APP_THEME);
    const isSystemLightTheme =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-color-scheme: light)').matches;
    const theme =
      storedTheme === 'light' || storedTheme === 'dark'
        ? storedTheme
        : isSystemLightTheme
          ? 'light'
          : 'dark';

    document.documentElement.dataset.theme = theme;
    document.body.dataset.theme = theme;
  }, []);

  return (
    <LoginTemplate isSignIn>
      <div>
        <AnimatePresence>
          {tenantOptions?.length ? <TenantSelectionForm tenants={tenantOptions} /> : otpEmailPreview ? <OtpAuthForm emailPreview={otpEmailPreview} /> : <SignInForm />}
        </AnimatePresence>
      </div>

      <div className="flex flex-col items-center gap-2">
        {/* <CxButton
          label="Cadastro"
          color={!isSignIn ? 'primary' : 'gray'}
          onClick={() => setIsSignIn(false)}
        /> */}
        {/* <CxButton
          label="Login"
          color={isSignIn ? 'primary' : 'gray'}
          onClick={() => setIsSignIn(true)}
        /> */}
      </div>
    </LoginTemplate>
  );
}
